import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getMenus,
  updateMenu,
  insertMenu,
  deleteMenu,
  getAllMenusParents,
  getMenuById,
} from 'services/configuracionPortal'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_MENUS() {
  try {
    const menusData = yield call(getMenus)
    if (menusData.ok) {
      yield put({
        type: actions.MENUS_LOAD_SUCCEEDED,
        payload: menusData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los menus')
      put({
        type: actions.MENUS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MENUS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ALL_MENUS_PARENTS() {
  try {
    const menusData = yield call(getAllMenusParents)
    if (menusData.ok) {
      yield put({
        type: actions.MENUS_LOAD_ALL_PARENTS_SUCCEEDED,
        payload: menusData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los menus')
      put({
        type: actions.MENUS_LOAD_ALL_PARENTS_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MENUS_LOAD_ALL_PARENTS_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_MENU(action) {
  try {
    const menuObj = yield call(insertMenu, action.payload)
    if (menuObj.ok) {
      putMessage(messageType.SUCCESS, 'Menu creado correctamente')
      yield put({
        type: actions.MENU_INSERT_SUCCEEDED,
        payload: menuObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Menu')
      yield put({
        type: actions.MENU_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Menu')
    yield all([
      put({
        type: actions.MENU_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_MENU(action) {
  try {
    const menuObj = yield call(updateMenu, action.payload)
    if (menuObj.ok) {
      putMessage(messageType.SUCCESS, 'Menu modificado correctamente')
      yield put({
        type: actions.MENU_UPDATE_SUCCEEDED,
        payload: menuObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Menu')
      yield put({
        type: actions.MENU_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Menu')
    yield all([
      put({
        type: actions.MENU_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_MENU(action) {
  try {
    const menuResult = yield call(deleteMenu, action.payload)
    if (menuResult.ok) {
      putMessage(messageType.SUCCESS, 'Menu eliminado correctamente')
      yield put({
        type: actions.MENU_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Menu')
      yield put({
        type: actions.MENU_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Menu')
    yield all([
      put({
        type: actions.MENU_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_MENU_BY_ID(action) {
  try {
    const menuData = yield call(getMenuById, action.payload)
    if (menuData.ok) {
      yield put({
        type: actions.MENU_BYID_LOAD_SUCCEEDED,
        payload: menuData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Menú')
      put({
        type: actions.MENU_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MENU_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.MENUS_LOAD_REQUESTED, GET_MENUS),
    takeEvery(actions.MENUS_LOAD_ALL_PARENTS_REQUESTED, GET_ALL_MENUS_PARENTS),
    takeEvery(actions.MENU_INSERT_REQUESTED, INSERT_MENU),
    takeEvery(actions.MENU_UPDATE_REQUESTED, UPDATE_MENU),
    takeEvery(actions.MENU_DELETE_REQUESTED, DELETE_MENU),
    takeEvery(actions.MENU_BYID_LOAD_REQUESTED, GET_MENU_BY_ID),
  ])
}
